export const usePlural = () => {
  const pluralizeSeconds = (number: number) => {
    const lastDigit = number % 10;
    const lastTwoDigits = number % 100;

    if (lastDigit === 1 && lastTwoDigits !== 11) {
      return `${number} секунду`;
    } else if (
      lastDigit >= 2 &&
      lastDigit <= 4 &&
      (lastTwoDigits < 10 || lastTwoDigits >= 20)
    ) {
      return `${number} секунды`;
    } else {
      return `${number} секунд`;
    }
  };

  return { pluralizeSeconds };
};
